import { useStoryParams } from "hooks/useUrlParams";
import * as React from "react";
import { useAsync } from "react-use";
import { apiClient } from "utils/apiClient";

interface ContextValue {
	loading: boolean;
	value?: any;
}
const ctx = React.createContext<ContextValue>({ loading: false });

export const RoomTemplatePageContentProvider = ({ children }) => {
	const story = useStoryParams();
	const url = `story/${story}`;

	const result = useAsync(async () => {
		if (story) {
			const response = await apiClient(url);
			return response.data;
		} else {
			return null;
		}
	}, [url]);
	const value = React.useMemo(() => result, [result]);

	return <ctx.Provider value={value}>{children}</ctx.Provider>;
};

export function useRoomTemplateLoginPageContext(): ContextValue {
	const context = React.useContext(ctx);
	if (!context) {
		throw new Error("useRoomTemplateLoginPageContext must be put within RoomTemplatePageContentProvider");
	}
	return context;
}
